module.exports = __webpack_public_path__ + "static/media/StephProf.9d9e980c.jpg";